import {Model} from './Model';
import {SessionStorageObject} from '../Utilities/SessionStorageObject';

export class Slot extends Model implements SessionStorageObject {
  public shortDescription: number = 0;
  public descriptionExternal: string = '';
  public descriptionInternal: string = '';
  public printStart: string | null = null;
  public printEnd: string | null = null;
  public quota: number = 0;
  public addToQrCode: number = 0;

  constructor(data: any) {
    super(data);
    this.shortDescription = data.shortDescription;
    this.descriptionExternal = data.descriptionExternal;
    this.descriptionInternal = data.descriptionInternal;
    this.printStart = data.printStart;
    this.printEnd = data.printEnd;
    this.quota = data.quota;
    this.addToQrCode = data.addToQrCode;
  }

  toString(): string {
    return `${this.shortDescription}`;
  }

  fromStorage(data: any) {
    return new Slot(data);
  }
}
